// App.jsx
import React, { useState } from "react";
import "./App.css";
import {  Modal } from 'antd';
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import { Labaratoriya } from "./Components/Labaratoriya";
import Test from "./Components/Test";
import { Muallif } from "./Components/Muallif";
import { Glossariy } from "./Components/Glossariy";
import { Foydalanilgan } from "./Components/Foydalanilgan";
import { Maruza } from "./Components/Maruza";
import { Amaliy } from "./Components/Amaliy";
import { MaruzaMatni } from "./Components/MaruzaMatni";
import { Meyoriy } from "./Components/Meyoriy";
import {Video} from './Components/Video'
import Titul from "./Components/Titul";

function App() {
  const [open, setOpen] = useState(false);
  const [content] = useState(null);
  const handleClose = () => setOpen(false);

  return (
    <div className="app-container">
      <Header />
      <Titul />
      <Meyoriy />
      <MaruzaMatni />
      <Maruza />
      <Amaliy />
      <Labaratoriya />
      <Video />
      <Glossariy />
      <Foydalanilgan />
      <Test />
      <Muallif />


      <Footer />

      <Modal open={open} onClose={handleClose}>
        {content}
      </Modal>
    </div>
  );
}

export default App;
